<template lang="pug">
  #companion-landscape-card
    RouterLink(:to="redirectTo")
      .flex-container
        .cover-art-container
          img.is-square(:src="previewImage" :alt="'Not available'")
        .custom-content-box
          .flex-item
            .flex-item.part-info
              span(v-if="partNumber") {{ partNumber }}
            .flex-item.title
              WtTitle {{ partTitle }}
          .flex-item
            .timer-container
              WtSvgIcon(icon="icon_time" width="20px" height="20px" style="padding-top: 4px;")
              span {{ duration }}
</template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "CompanionGuideCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    redirectTo: { type: String, required: true },
    id: { type: String, default: "" },
    partNumber: { type: String, default: null },
    partId: { type: String, default: "" },
    partTitle: { type: String, default: "" },
    duration: { type: String, default: "" },
    previewImage: { type: String, default: "" },
    subTitle: { type: String, default: "" }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
#companion-landscape-card {
  border: 1px solid #d9dbe0;
  border-radius: 0.75rem;
  background-color: white !important;
  font-family: "Manrope" !important;
  font-weight: 600;
  min-width: 334px;
  height: min-content !important;
}

.flex-container {
  display: flex !important;
  flex-direction: row !important;
  gap: 16px !important;
  padding: 16px !important;
}

.cover-art-container {
  width: 96px !important;
  min-height: 124px !important;
  display: flex !important;
  align-items: center !important;
}

.cover-art-container img {
  border-radius: 0.5rem !important;
  height: 100% !important;
  width: 100% !important;
}
.custom-content-box {
  width: 61% !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
}

.title {
  color: #1b1d20;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 20px !important;
  font-family: Manrope !important;
  font-style: normal !important;
}

.part-info {
  color: #5a5c60 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  font-style: normal !important;
  font-family: Manrope !important;
  color: #5a5c60;
}

.timer-container {
  display: flex !important;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  gap: 4px;
  color: #5a5c60;
  font-family: Manrope;
  font-style: normal;
}

.timer-container span {
  margin-left: 0rem;
}

@media screen and (max-width: 768px) {
  #companion-landscape-card {
    min-width: 324px;
    height: max-content !important;
  }
}

@media screen and (max-width: 480px) {
  #companion-landscape-card {
    min-width: 100% !important;
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }

  .cover-art-container {
    display: flex !important;
    align-items: center !important;
    width: 96px !important;
    gap: 8px !important;
  }
  .cover-art-container img {
    border-radius: 0.5rem !important;
    width: 100% !important;
    height: 124px !important;
    object-fit: cover !important;
  }
  .custom-content-box {
    display: flex !important;
    width: 61% !important;
    gap: 16px;
    flex-direction: column !important;
    justify-content: space-between !important;
    align-items: flex-start !important;
  }
}
</style>
